// extracted by mini-css-extract-plugin
export default {"nameRow":"HotelFuzzyMatchName_nameRow__de1HG","name":"HotelFuzzyMatchName_name__-mo5S"};